import i18n from '@nextroll/ar-i18n';
// @ts-ignore - no types for ar-style-base
import { WizardProgressHeader } from '@nextroll/ar-style-base';

// @ts-ignore - no types for an image.
import HannahLewis from '../../assets/shopify-sign-up/hannah-lewis.png';
// @ts-ignore - no types for an image.
import Pinkdots from '../../assets/shopify-sign-up/pinkdots.svg';
// @ts-ignore - no types for an image.
import Wave from '../../assets/shopify-sign-up/wave.svg';
// @ts-ignore - no types for an image.
import Wing from '../../assets/shopify-sign-up/wing.png';
import Footer from '../../components/Footer';
import { SignUpModes } from '../../constants';
import SignUpForm from '../../forms/sign-up/SignUpForm';

const pinkdots = `${process.env.STATIC_PATH}${Pinkdots}`;
const wing = `${process.env.STATIC_PATH}${Wing}`;
const hannahlewis = `${process.env.STATIC_PATH}${HannahLewis}`;
const wave = `${process.env.STATIC_PATH}${Wave}`;

const SHOPIFY_SOURCE = 'shopify_2022_03';

const ShopifySignUpPage = () => {
    // This page does not use eh-page because its page style is different from other pages (no padding for example).
    return (
        <section className='eh-page-shopify-sign-up'>
            <div className='eh-shopify-sign-up-topbar'>
                <WizardProgressHeader currentStep={1} totalSteps={5} />
            </div>
            <div className='eh-shopify-sign-up-content'>
                <div className='eh-shopify-sign-up-content-left'>
                    <h1>{i18n.gettext('Welcome to AdRoll!')}</h1>
                    <p>
                        {i18n.gettext(
                            "We've filled out your account information from you Shopify store, all we need is an AdRoll password."
                        )}
                    </p>
                    <SignUpForm
                        mode={SignUpModes.SHOPIFY}
                        source={SHOPIFY_SOURCE}
                    />
                    <Footer />
                </div>

                <div className='eh-shopify-sign-up-content-right'>
                    <div className='eh-shopify-sign-up-dot-container'>
                        <img src={pinkdots} alt={i18n.gettext('pinkdots')} />
                    </div>
                    <div className='eh-shopify-sign-up-right-side-text'>
                        <div className='eh-shopify-sign-up-wing-container'>
                            <img src={wing} alt={i18n.gettext('wing')} />
                        </div>
                        <div>
                            <h2 className='eh-shopify-sign-up-headline'>
                                {i18n.gettext(
                                    `The AdRoll app for Shopify integrated <br/>
                                        incredibly easily and efficiently for us — <br/>
                                        what can take weeks or even months for <br/>
                                        developers to implement took just <br/>
                                        minutes. The integration is brilliant.`
                                )}
                            </h2>
                        </div>
                        <div className='eh-shopify-sign-up-autor'>
                            <img
                                src={hannahlewis}
                                alt={i18n.gettext('Hannah Lewis')}
                            />
                            <p className='eh-shopify-sign-up-autor-name'>
                                {i18n.gettext(
                                    `-Hannah Lewis, head of PPC & Affiliates at Lounge <br/>
                                        AdRoll & Shopify Plus Merchant`
                                )}
                            </p>
                        </div>
                    </div>
                    <div className='eh-shopify-sign-up-wave-container'>
                        <img src={wave} alt={i18n.gettext('wave')} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ShopifySignUpPage;
